import React, { FC } from 'react';
import parse from 'html-react-parser';
import dayjs from 'dayjs';
import { INote } from 'entities/Notes/Note.models';

interface IComponentProps {
  note: INote;
}

export const HistoryNote: FC<IComponentProps> = ({ note }) => {
  return (
    <div className="mb-4 pb-4 history-item">
      <div className="mb-4 d-flex align-center history-item__header">
        <span className="ff-regular color-grey">{dayjs(note.createdAt).format('MM/DD/YY - hh:mma')}</span>

        <span className="ff-regular color-grey">{`by: ${note.userName}`}</span>
      </div>

      <div className="mb-4 ff-regular history-item__message note">{parse(note.note)}</div>
    </div>
  );
};
